import { analyticsUrl } from 'utils/wrappers';

import PageableBase from 'app/collections/pageable_base';

export default PageableBase.extend({
  key: 'carriers',
  url: analyticsUrl('tracking/v2/carriers'),

  initialize(models, { staticParams = {} }) {
    this.staticParams = staticParams;
  },

  additionalParamsForFetch() {
    return { enabled: true, ...this.staticParams };
  },
});



// WEBPACK FOOTER //
// ./app/collections/analytics_carriers.js